import { useMemo } from 'react';
import { createCampaignsService } from 'src/services/campaigns/campaigns.service';
import useAuthedRequest from './useAuthedRequest';

export const useCampaigns = () => {
  const authedRequest = useAuthedRequest();

  const campaignsService = useMemo(
    () => createCampaignsService(authedRequest),
    [authedRequest],
  );

  return campaignsService;
};
